import axios from 'axios';
import get from 'lodash/get';
import { getJwtToken } from './auth';

import { Amplify } from '@aws-amplify/core';
import config from '../config';

// const token = localStorage.getItem('ap_idToken');
Amplify.configure(config);

const NotificationEmailsAxiosConfig = axios.create({
  baseURL: 'https://zl4qv9fgb1.execute-api.us-west-2.amazonaws.com/dev/Notifycation/',
  //baseURL: 'http://localhost:9001/trackrecord',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: getJwtToken(),
  },
});

const handleErroredResponse = async (error) => {
  const originalRequest = get(error, ['response', 'config'], undefined);
  const statusCode = get(error, ['response', 'status'], undefined);
  const errMessage = get(error, ['response', 'data', 'name'], undefined);
  const errData = get(error, ['response', 'data'], undefined);

  if (statusCode === 401) {
    if (errMessage === 'TokenExpiredError') {
      // remove token from local storage, if applicable
      // call for new id token
      // store token in token variable
      const token = await getJwtToken();
      if (token) {
        axios.defaults.headers.common['Authorization'] = token;
      }
      return NotificationEmailsAxiosConfig(originalRequest);
    }
  }

  if (errData) {
    return Promise.reject(errData);
  }
  return Promise.reject(error.message);
};

NotificationEmailsAxiosConfig.interceptors.request.use(
  async (config) => {
    const aConfig = config;
    // call for id token and store in authToken variable
    const authToken = await getJwtToken();
    if (authToken) {
      aConfig.headers['Authorization'] = authToken;
    }
    return aConfig;
  },
  (error) => Promise.reject(error)
);

NotificationEmailsAxiosConfig.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    return await handleErroredResponse(error);
  }
);

export default NotificationEmailsAxiosConfig;
